import React, { useState } from "react";
import { Upload, Button, Progress, message, Table, Spin } from "antd";
import { UploadOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";

const headers = ['No', '要求番号', '品名', '規格', '単位', '数量', '単価', '金額', '倉庫'];

const GeminiPdfUploaderSSE = ({ user, token }) => {
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [step, setStep] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    // fetch("http://localhost:5000/start-processing", {
    //     method: "POST",
    //     headers: {
    //         "Authorization": "Bearer test"
    //     }
    // })
    //     .then(res => res.json())
    //     .then(console.log)


    // Adjust to your Cloud Run URL
    const CLOUD_RUN_URL = 'https://gemini-pdf-service-69840953302.us-central1.run.app';
    const clientId = uuidv4();

    const handleUpload = async () => {
        if (!file) {
            message.warning("Please select a PDF file first.");
            return;
        }

        setProgress(0);
        setStep("");
        setData([]);
        setLoading(true);

        setProgress(5);
        setStep("Uploading PDF...");

        const formData = new FormData();
        formData.append("file", file);

        // 1️⃣ Start processing
        const startResponse = await fetch(
            `${CLOUD_RUN_URL}/start-processing?client_id=${clientId}`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
                credentials: "include"
            }
        );

        if (!startResponse.ok) {
            setLoading(false);
            message.error("Failed to start processing.");
            return;
        }

        // 2️⃣ Start listening to SSE progress
        const evtSource = new EventSource(
            `${CLOUD_RUN_URL}/progress-stream?client_id=${clientId}&token=${token}`
        );

        evtSource.onmessage = async (event) => {
            if (event.data === "__COMPLETE__") {
                evtSource.close();
                setStep("Fetching final data...");
                // 3️⃣ Fetch final JSON result
                const resultResponse = await fetch(
                    `${CLOUD_RUN_URL}/get-result?client_id=${clientId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (resultResponse.ok) {
                    const json = await resultResponse.json();
                    // console.log('json', json)
                    const processedData = json.map((item, idx) => ({
                        key: idx,
                        ...item,
                        数量: Number(item.数量).toFixed(2),
                        単価: Number(item.単価) === 0 ? "" : Number(item.単価).toLocaleString(),
                        金額: Number(item.金額) === 0 ? "" : Number(item.金額).toLocaleString(),
                    }));
                    setData(processedData);
                    setProgress(100);
                    setStep("Done!");
                    setLoading(false);
                    message.success("Processing completed!");

                    // Create Excel filename based on PDF
                    const baseName = file.name.replace(/\.[^/.]+$/, "");
                    const excelFilename = `${baseName}.xlsx`;

                    const exportData = processedData.map(({ key, ...rest }) => rest);

                    // Create worksheet from JSON
                    const worksheet = XLSX.utils.json_to_sheet(exportData, {header: headers});

                    // Create workbook
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

                    // Generate Excel and trigger download
                    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
                    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                    const url = URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", excelFilename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } else {
                    setLoading(false);
                    message.error("Failed to fetch results.");
                }

                return;
            }

            const json = JSON.parse(event.data);
            setStep(json.step);
            setProgress(json.progress);
        };

        evtSource.onerror = (err) => {
            console.error("EventSource error:", err);
            evtSource.close();
            setLoading(false);
            message.error("Progress connection failed.");
        };
    };

    const columns = headers.map((key) => ({
        title: key,
        dataIndex: key,
        key,
        ellipsis: true,
        render: (value) => {
            switch (key) {
                case '数量': return Number(value).toFixed(2);
                case '単価': return value ? Number(value).toLocaleString() : '';
                case '金額': return value ? Number(value).toLocaleString() : ''
                default: return value
            }
        }
    }));

    //wzxXDdm7QXiGpCywXsXw
    // console.log('user', user) //"9hlB2doCGWzPUJBbLvZ3"

    return (
        <div>
            {user && user.organization === "wzxXDdm7QXiGpCywXsXw" ? <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24, display: 'flex', flexDirection: 'column', gap: 10 }}>
                <h2>PDF ➝ Table</h2>
                <Upload
                    beforeUpload={(file) => {
                        setFile(file);
                        setProgress(0);
                        setStep("");
                        setData([]);
                        message.info(`Selected file: ${file.name}`);
                        return false;
                    }}
                    maxCount={1}
                    accept=".pdf"
                >
                    <Button icon={<UploadOutlined />}>Select PDF</Button>
                </Upload>

                <Button
                    type="primary"
                    icon={<CloudUploadOutlined />}
                    style={{ width: 200 }}
                    onClick={handleUpload}
                    disabled={!file || loading}
                >
                    Start Processing
                </Button>

                {loading && (
                    <div style={{ marginTop: 24 }}>
                        <Progress percent={progress} />
                        <div>{step}</div>
                    </div>
                )}

                {!loading && data.length > 0 && (
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        pagination={false}
                        scroll={{ x: "max-content" }}
                        style={{ marginTop: 24 }}
                    />
                )}
            </div> : <></>}
        </div>
    );
};

export default GeminiPdfUploaderSSE;
